import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery, handleSessionExpiredError } from '../../utils/auth';
import { Campus, ViewFinder } from './types';

// Define a service using a base URL and expected endpoints
export const settingsApi = createApi({
  reducerPath: 'settingsApi',
  baseQuery: getBaseQuery('/mantainer-portal/campus'),
  endpoints: (builder) => ({
    getContractViewfinder: builder.query<Campus[], void>({
      query: () => ({
        url: '/',
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
    saveContractViewfinderSetting: builder.mutation<
      void,
      { campusId: number; viewfinders: ViewFinder[] }[]
    >({
      query: (data) => ({
        method: 'PUT',
        url: '/viewfinders',
        body: { data },
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),

    saveRateSettings: builder.mutation<void, string | number>({
      query: (hourValue) => ({
        method: 'PUT',
        url: '/hour-value',
        body: {
          hourValue,
        },
      }),
      transformErrorResponse: (response) => handleSessionExpiredError(response),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetContractViewfinderQuery,
  useSaveContractViewfinderSettingMutation,
  useSaveRateSettingsMutation,
} = settingsApi;
